import { FormGroup, FieldTemplate, FieldInstanceForResolver } from "../../db/definitions";
import { batchAddFieldInstances } from "../../graphql/mutations";
import { generateClient } from "aws-amplify/api";
import { recordSentry } from "utils/recordSentry";

// ============================
// Helper Functions for Batch Operations
// ============================

export function normalizeKey(rawValue: string | null | undefined): string {
	return (rawValue || "").trim().toLowerCase();
}

export function buildRowValueMap(csvHeaders: string[], csvRow: string[]): Map<string, string> {
	const rowMap = new Map<string, string>();
	for (let i = 0; i < csvHeaders.length; i++) {
		const normalizedHeader = normalizeKey(csvHeaders[i]);
		const rawValue = csvRow[i] || "";
		rowMap.set(normalizedHeader, rawValue);
	}
	return rowMap;
}

export function getApplicableFormGroupIds(fieldTemplate: FieldTemplate, fieldInstances: FieldInstanceForResolver[]): string[] {
	// Find all FormGroups that have FieldInstances using this FieldTemplate
	const formGroupIds: string[] = [];
	for (const fieldInstance of fieldInstances) {
		if (fieldInstance.fieldTemplateId === fieldTemplate.id) {
			formGroupIds.push(fieldInstance.formGroup);
		}
	}
	return [...new Set(formGroupIds)]; // dedupe
}

export function chooseIdentityCsvKey(templateIds: string[], fieldTemplateById: Map<string, FieldTemplate>): string | null {
	// Prefer Temporary over Resource, but collect both for composite identity support
	let temporaryKey: string | null = null;
	let resourceKey: string | null = null;

	for (const templateId of templateIds) {
		const template = fieldTemplateById.get(templateId);
		if (!template?.csvKey) continue;

		if (template.identityRole === "temporary") {
			temporaryKey = normalizeKey(template.csvKey);
		} else if (template.identityRole === "resource") {
			resourceKey = normalizeKey(template.csvKey);
		}
	}

	// Return the preferred key, but the system now validates against all available identity fields
	return temporaryKey || resourceKey;
}
